import bemCssModules from 'bem-css-modules';
import type { VFC } from 'react';

import { LocalizationItem } from '../../constants/LocalizationItem';
import { LocalizedText } from '../LocalizedText/LocalizedText';
import BreadcrumbsItemModuleCss from './BreadcrumbsItem.module.css';

const block = bemCssModules(BreadcrumbsItemModuleCss);

export const HomeBreadcrumb: VFC = () => (
  <a
    className={block()}
    href={window.location.origin}
  >
    <span className={block('name')}>
      <LocalizedText localizationItem={LocalizationItem.Home} />
    </span>
  </a>
);
